import { Container } from '@chakra-ui/react'
import { Navigate, useNavigate } from 'react-router-dom'
import { Section } from '../../components/Section'
import { useAuth } from '../../context/AuthContext'
import { redirectToLogout } from '../../hooks/useAccount'

const LogoutPage = () => {
    var auth = useAuth()
    auth?.logout()

    return <Navigate to={'/auth/login'} />
}

export default LogoutPage